/** @flow */

import React from "react";
import { compose } from "redux";
import { localize } from "redux-i18n";
import { connect } from "react-redux";
import { Page } from "react-page-layout";
import { push } from "connected-react-router";
import { TitleSection, Loader, View, Text } from "@components";
import { getRouteParams } from "@selectors";
import type { State } from "@store/reducers";
import { withClientContext, type PropsFromClientContext } from "@modules/context/components";
import {
  withPermissions,
  PermissionEnum,
  type PropsFromPermissions,
} from "@modules/account/components";
import withErrorHandler from "@components/error";
import actionCreators from "@modules/reporting/actionCreator";
import { getEmployeeName } from "@modules/employee/selectors";
import type { EmployeeType } from "@modules/employee/types";
import { getDetails } from "@modules/reporting/selectors/manager/manager-details";
import { EmployeeAbsencesTable } from "@modules/shared/components";
import { getPermissions } from "@modules/account/selectors";
import employeeActionCreators from "@modules/employee/actionCreator";

type PropsFromState = $Exact<{
  employeeId: number,
  employee: ?EmployeeType,
}>;

type PropsFromDispatch = $Exact<{
  navigate: typeof push,
  getManagerDetails: typeof actionCreators.GetManagerDetails,
  getEmployees: typeof employeeActionCreators.getEmployees,
}>;

type Props = $Exact<{
  ...PropsFromState,
  ...PropsFromDispatch,
  ...PropsFromLocalize,
  ...PropsFromClientContext,
  ...PropsFromPermissions,
}>;

export class EmployeeAbsences extends React.Component<Props> {
  componentDidMount() {
    this.props.getManagerDetails({
      clientId: this.props.clientId,
      employeeId: this.props.employeeId,
    });

    this.props.getEmployees({
      clientId: this.props.clientId,
      filters: {
        id: this.props.employeeId,
      },
    });
  }

  render() {
    return (
      <View gap="6" position="relative">
        <Text className="message-box" text={this.props.t("EMPLOYEE_ABSENCES_TAB_INFO")} />
        <EmployeeAbsencesTable
          clientId={this.props.clientId}
          employeeId={this.props.employeeId}
          absenceDetailsRoute="REPORTING_EMPLOYEE_ABSENCE_DETAILS_PATH"
          withFilters
        />
      </View>
    );
  }
}

const mapStateToProps = (state: State, ownProps): PropsFromState => {
  const routeParams = getRouteParams(ownProps);
  const employeeId = parseInt(routeParams.employeeId);

  return {
    employeeId,
    employee: getDetails(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  navigate: push,
  getManagerDetails: actionCreators.GetManagerDetails,
  getEmployees: employeeActionCreators.GetEmployees,
};

export default compose(
  withErrorHandler(),
  localize(),
  connect(mapStateToProps, mapDispatchToProps),
  withClientContext(),
  withPermissions({ permissionId: PermissionEnum.ACCESS_REPORTING_EMPLOYEES }),
)(EmployeeAbsences);
